module.exports = __webpack_public_path__ + "img/checkmark.5d651f1a.svg";